<ng-container *ngIf="lineItemFormGroup">
	<div class="line-item-modify" [formGroup]="lineItemFormGroup" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
		<flx-credit-note-line-item-generator [isNonVatSP]="isNonVatSP" [index]="index" [actualLineItemsFormArray]="actualLineItemsFormArray"></flx-credit-note-line-item-generator>

		<span class="line-item-modify__add-btn"> <flx-icon [type]="'circle-add'" color="primary" (click)="addItem.emit()"></flx-icon> </span>
		<span class="line-item-modify__remove-btn"> <flx-icon [type]="'remove'" color="warning" (click)="removeItem.emit()"></flx-icon> </span>
	</div>
</ng-container>
